import React, { useState, useEffect, useCallback } from "react";
import {
  Arrow,
  BannerButton,
  BannerContainer,
  BannerDescription,
  BannerImage,
  BannerSlide,
  BannerTitle,
  BannerWrapper,
  CarouselDots,
  ContentColumn,
  Dot,
  ImageColumn,
  NavigationButton,
} from "./style";
import useZoom from "../../../hooks/zoom";
import { FormattedMessage } from "react-intl";
import { useAcademy } from "../../InformaAcademy/Hook/useAcademy.hook";

const BannerCaroussel = ({ banners = [] }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [translate, setTranslate] = useState(0);
  const [actionTriggered, setActionTriggered] = useState(false);
  const { scale } = useZoom();
  const { postBannerAnalyticsAction } = useAcademy();

  const nextSlide = useCallback(() => {
    const next = currentSlide === banners.length - 1 ? 0 : currentSlide + 1;

    setCurrentSlide(next);
    setTranslate(-next * 100);
  }, [banners, currentSlide]);

  const prevSlide = () => {
    const prev = currentSlide === 0 ? banners.length - 1 : currentSlide - 1;
    setCurrentSlide(prev);
    setTranslate(-prev * 100);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setTranslate(-index * 100);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 10_000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  useEffect(() => {
    postBannerAnalyticsAction({
      action: "IMPRESSION",
      bannerId: banners[currentSlide]?.id,
    });
  }, [banners, currentSlide, postBannerAnalyticsAction]);

  useEffect(() => {
    if (currentSlide === banners.length - 1 && !actionTriggered) {
      banners.map((banner) => {
        return postBannerAnalyticsAction({
          bannerId: banner.id,
          action: "VIEWS",
        });
      });
      setActionTriggered(true);
    }
  }, [actionTriggered, banners, currentSlide, postBannerAnalyticsAction]);

  if (!banners || banners.length === 0) return null;

  return (
    <BannerContainer>
      {banners.length > 1 && (
        <>
          <NavigationButton direction="prev" onClick={prevSlide}>
            <Arrow direction="prev" />
          </NavigationButton>
          <NavigationButton direction="next" onClick={nextSlide}>
            <Arrow direction="next" />
          </NavigationButton>
        </>
      )}
      <BannerWrapper translate={translate}>
        {banners.map((banner, index) => (
          <BannerSlide key={index} index={index}>
            <ContentColumn>
              <BannerTitle>{banner.title}</BannerTitle>
              <BannerDescription
                scale={scale}
                dangerouslySetInnerHTML={{ __html: banner.description }}
              />
              {banner.buttonUrl && (
                <BannerButton
                  href={banner.buttonUrl}
                  onClick={() =>
                    postBannerAnalyticsAction({
                      bannerId: banners[currentSlide]?.id,
                      action: "INTERACTION",
                    })
                  }
                  target="_blank"
                >
                  <FormattedMessage id="homepage.details" />
                </BannerButton>
              )}
            </ContentColumn>
            <ImageColumn>
              <BannerImage src={banner.bannerImage.url} alt={banner.title} />
            </ImageColumn>
          </BannerSlide>
        ))}
      </BannerWrapper>
      {banners.length > 1 && (
        <CarouselDots>
          {banners.map((_, index) => (
            <Dot
              key={index}
              active={currentSlide === index}
              onClick={() => goToSlide(index)}
            />
          ))}
        </CarouselDots>
      )}
    </BannerContainer>
  );
};

export default BannerCaroussel;
